const SLA_TIME_UNITS = { y: 31536000, mo: 2592000, d: 86400, h: 3600, m: 60 };

export const formatSLATime = seconds => {
  if (seconds < 60) return '1m';
  const parts = [];
  let remaining = seconds;
  Object.entries(SLA_TIME_UNITS).forEach(([unit, value]) => {
    if (parts.length >= 2 || (remaining < 60 && parts.length > 0)) return;
    const count = Math.floor(remaining / value);
    if (count > 0) {
      parts.push(`${count}${unit}`);
      remaining -= count * value;
    }
  });
  return parts.join(' ');
};

export const evaluateBusinessHoursSLA = (appliedSla, chat) => {
  const types = [];

  if (
    appliedSla.sla_frt_remaining != null &&
    appliedSla.sla_first_response_time_threshold
  ) {
    const firstReply = chat.first_reply_created_at || chat.firstReplyCreatedAt;
    if (!firstReply || firstReply === 0) {
      types.push({ type: 'FRT', threshold: appliedSla.sla_frt_remaining });
    }
  }

  if (
    appliedSla.sla_nrt_remaining != null &&
    appliedSla.sla_next_response_time_threshold
  ) {
    const firstReply = chat.first_reply_created_at || chat.firstReplyCreatedAt;
    const waitingSince = chat.waiting_since || chat.waitingSince;
    if (firstReply && waitingSince) {
      types.push({ type: 'NRT', threshold: appliedSla.sla_nrt_remaining });
    }
  }

  if (
    appliedSla.sla_rt_remaining != null &&
    appliedSla.sla_resolution_time_threshold
  ) {
    if (chat.status === 'open') {
      types.push({ type: 'RT', threshold: appliedSla.sla_rt_remaining });
    }
  }

  if (types.length === 0) {
    return { type: '', threshold: '', icon: '', isSlaMissed: false };
  }

  types.sort((a, b) => Math.abs(a.threshold) - Math.abs(b.threshold));
  const mostUrgent = types[0];
  return {
    type: mostUrgent.type,
    threshold: formatSLATime(
      mostUrgent.threshold <= 0
        ? -mostUrgent.threshold
        : mostUrgent.threshold
    ),
    icon: mostUrgent.threshold <= 0 ? 'flame' : 'alarm',
    isSlaMissed: mostUrgent.threshold <= 0,
  };
};

export const hasBusinessHoursSLAData = appliedSla => {
  return (
    appliedSla?.sla_only_during_business_hours &&
    (appliedSla?.sla_frt_remaining != null ||
      appliedSla?.sla_nrt_remaining != null ||
      appliedSla?.sla_rt_remaining != null)
  );
};
